export default function Spinner () {
  return (
    <svg width="100%" height="100%" className="animate-pulse" viewBox="0 0 300 300" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="#453EDA" d="M20 26C20 22.6863 22.6863 20 26 20H134C137.314 20 140 22.6863 140 26V134C140 137.314 137.314 140 134 140H26C22.6863 140 20 137.314 20 134V26Z"/>
      <path fill="#453EDA" d="M20 166C20 162.686 22.6863 160 26 160H134C137.314 160 140 162.686 140 166V274C140 277.314 137.314 280 134 280H26C22.6863 280 20 277.314 20 274V166Z"/>
      <path fill="#453EDA" d="M160 26C160 22.6863 162.686 20 166 20H274C277.314 20 280 22.6863 280 26V134C280 137.314 277.314 140 274 140H166C162.686 140 160 137.314 160 134V26Z"/>
    </svg>
  )
}
